const InframouraLogo = (props: any) => {
  return <img className="InframouraLogo" src="inframoura_logo.svg" alt="Inframoura Logo" />;
};

export default InframouraLogo;
